import * as React from 'react';
import 'twin.macro';
import 'styled-components/macro';

import { Tooltip } from 'component-lib/atoms/tooltip/Tooltip';

export interface InfoTooltipProps extends React.HTMLAttributes<HTMLSpanElement> {}

export const InfoTooltip = ({ children, ...rest }: InfoTooltipProps) => (
  <span tw="hidden md:inline-block relative" {...rest}>
    <Tooltip content={children}>
      <span tw="cursor-default flex items-center justify-center rounded-full bg-secondary-lighter text-secondary h-2 w-2 text-xs font-semibold">
        ?
      </span>
    </Tooltip>
  </span>
);
